import { useMemo } from 'react';

// components
import DialogHeader from '../DialogHeader';
import UserRolesList, { UserRolesListProps } from 'components/sections/UserRolesList';

// Mui
import { Theme } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, Divider, useMediaQuery } from '@mui/material';

// hooks
import useEnums from 'hooks/useEnum';
import useUserTopRoleInfo from 'hooks/useUserTopRoleInfo';

interface UserRolesDialogProps extends Omit<DialogProps, 'onClose'> {
  onClose?: () => void;
  userRolesListProps: UserRolesListProps;
}

function UserRolesDialog({ userRolesListProps, onClose, ...others }: UserRolesDialogProps) {
  const matchDownMD = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const { UserRolesEnum } = useEnums();
  const { userTopRoleId } = useUserTopRoleInfo();

  const handleClose = () => {
    onClose?.();
  };

  const forbiddenRoleIds = useMemo(() => [UserRolesEnum.NOTIFICATION_CONTACT], [UserRolesEnum.NOTIFICATION_CONTACT]);
  const isPO = userTopRoleId === UserRolesEnum.PROPERTY_OPERATOR;
  const header = isPO ? 'Properties' : 'User Roles';

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: 600, height: 400 } }}
      maxWidth={matchDownMD ? 'sm' : 'lg'}
      {...others}
      onClose={handleClose}
    >
      <DialogHeader onClose={handleClose}>{header}</DialogHeader>
      <Divider />
      <DialogContent>
        <UserRolesList {...userRolesListProps} forbiddenRoleIds={forbiddenRoleIds} view={isPO ? 'po' : 'default'} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" sx={{ mr: 0.5 }} onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UserRolesDialog;
